/**
 *  Expose all available tracking events
 */
var TrackingEvents = (function(root, doc, undefined) {

    'use strict';

    return {
        INTERFACE_LANGUAGE_SELECTED: 'interface_language_selected',
        COURSE_SELECTED: 'course_selected',
        PAGE_INIT: 'page_init',
        USER_LOGIN_SUCCESS: 'user_login_success',
        USER_LOGIN_FAILED: 'user_login_failed',
        USER_REGISTERED_SUCCESS: 'user_register_success',
        USER_REGISTERED_FAILED: 'user_register_failed',
        PAGE_VIEW_HOME: 'homepage_view',
        PAGE_VIEW_INDITEX_LANDING: 'inditex_landing_page_viewed',
        PAGE_VIEW_COURSE_SELECTION: 'course_selection_viewed',
        PAGE_VIEW_LOGIN_PAGE: 'login_page_viewed',
        PAGE_VIEW_REGISTER_PAGE: 'registration_page_viewed',
        PAGE_VIEW_PREMIUM: 'paywall_viewed',
        PAGE_VIEW_PURCHASE: 'cart_entered',
        PAGE_VIEW_AUTOAUTH: 'autoauth_viewed',
        PURCHASE_METHOD_SELECTED: 'cart_psp_change',
        PURCHASE_FAILURE: 'purchase_failed',
        PURCHASE_SUCCESS: 'purchase_success',
        AUTOAUTH_SUCCESS: 'autoauth_success',
        CONTACT_SENT_SUCCESS: 'busuu_org_contact_sent',
        PAYWALL_SEEPLANS_CLICKED: 'paywall_see_all_plans_clicked',
        PAYWALL_SECTION_VIEWED: 'anchor_tab_viewed',
        STUDY_PLAN_CONFIRMED: 'study_plan_confirmed',
        CAPTCHA_STARTED: 'captcha_started',
        CAPTCHA_PASSED: 'captcha_passed',
        CAPTCHA_NOT_PASSED: 'captcha_not_passed',
    };

})(window, document);

module.exports = TrackingEvents;
